<one-card [notPadding]="true">

  <div class="fh-table-header">
    <span class="fh-table-title">Purchase orders</span>
    <one-input
      class="fh-search"
      label="Search"
      type="search"
      autocomplete="off"
      (input)="onSearch($event)"
    ></one-input>
  </div>

  <div class="fh-divider"></div>

  <div class="fh-filters">
    <div class="fh-filter-item">
      <one-select
        #companySelect
        class="one-select standard"
        [config]="selectConfig"
        [multiple]="true"
        [dataSource]="companyDataSource"
        label="Company"
        size="small"
        (selectionChanged)="onCompanyChange(companySelect.control.value)"
      ></one-select>
    </div>
    <div class="fh-filter-item">
      <one-select
        #sourceTypeSelect
        class="one-select standard"
        [config]="selectConfigNoSearch"
        [multiple]="true"
        [dataSource]="sourceTypeDataSource"
        label="Source type"
        size="small"
        (selectionChanged)="onSourceTypeChange(sourceTypeSelect.control.value)"
      ></one-select>
    </div>
    <div class="fh-filter-item">
      <one-select
        #statusSelect
        class="one-select standard"
        [config]="selectConfig"
        [multiple]="true"
        [dataSource]="statusDataSource"
        label="Status"
        size="small"
        (selectionChanged)="onStatusChange(statusSelect.control.value)"
      ></one-select>
    </div>
  </div>

  <one-dynamic-table *ngIf="tableData" [tableData]="tableData"></one-dynamic-table>

</one-card>

<ng-template #sourceTypeTemplate let-sourceType="sourceType" let-colorClass="colorClass">
  <span class="fh-source-badge" [ngClass]="colorClass">
    <span class="fh-source-dot"></span>{{ sourceType }}
  </span>
</ng-template>

<ng-template #statusTemplate let-status="status" let-label="label">
  <span class="fh-status-badge" [ngClass]="'fh-status--' + status">{{ label }}</span>
</ng-template>

<ng-template #actionsTemplate let-po="po">
  <div class="fh-row-actions">
    <button class="fh-row-actions__btn" (click)="viewOrder(po)" title="View purchase order">
      <span class="one-icon-eye"></span>
    </button>
  </div>
</ng-template>
